<template>
    <div class="chatbox">
      <ChatBox ref="chat" :streaming="streaming"/>
    </div>
  </template>

  <script>
  import ChatBox from "@/components/ChatBox";
  export default {
    props:{streaming:String},
    components: { ChatBox },
    mounted() {
      // this.$refs.chat.getToken();
    },
  };
  </script>
